import {useMemo} from 'react';

import {addMinutes} from 'date-fns';
import {useSelector} from 'react-redux';

import {toDateTime} from 'Components/BookingBlocksWidget/utils';

/**
 * Hook to check if the auto refund limit is reached
 * @param {Date} startDateTime
 * @param {String} timeZone
 * @param {Number?} autoRefundPolicy
 * @return {boolean}
 */
const useIsAutoRefundLimit = (startDateTime, timeZone, autoRefundPolicy) => {
  const autoRefundPolicyStore = useSelector((s) => s.bookAppointments.autoRefundPolicy);
  const policy = autoRefundPolicy ?? autoRefundPolicyStore;

  const limitTime = useMemo(() => policy > 0 ?
    toDateTime(addMinutes(toDateTime(startDateTime, timeZone).valueOf(), -policy * 60), timeZone).valueOf() :
    0,
  [policy, startDateTime, timeZone]);
  const isAutoRefundLimit = (policy === -1 || Date.now() > limitTime) && policy !== 0;

  return isAutoRefundLimit;
};

export default useIsAutoRefundLimit;
